<template lang="pug">
transition(name="fade")
  .object-info(v-show="show")
    table
      tr(v-for="(h, i) in keys")
        th {{h}}
        td {{values[i]}}
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { FrameStore } from "@/modules/base";
import { CatalogOverplotModule, IRowRef } from "@/modules/CatalogOverplotModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof CatalogOverplotModule>

  keys: string[] = []
  values: any[] = []
  show = false

  timer?: ReturnType<typeof setTimeout>

  created() {
    this.frameStore.$on('hover-object', (rowRef: IRowRef | null) => {
      if (rowRef) {
        this.show = true
        this.keys = rowRef.co.header
        this.values = rowRef.co.rows[rowRef.i]
      } else {
        this.hideInfoTableLater()
      }
    })
  }

  clearTimeout() {
    if (this.timer !== undefined) {
      clearTimeout(this.timer)
      this.timer = undefined
    }
  }

  hideInfoTableLater() {
    this.clearTimeout()
    this.timer = setTimeout(() => this.show = false, 400)
  }
}
</script>


<style lang="scss" scoped>
.object-info {
  color: white;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgba(31, 31, 31, 0.75);
  border-radius: 0 4pt 0 0;
  pointer-events: none;
  th {
  text-align: right;
  }
  td {
  padding: 0 1em;
  font-family: monospace;
  }
}

.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-leave-to {
  opacity: 0;
}
</style>